/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Paste_New_TokenInputs */



/**
* | output |
* | --- |
* | "Paste new token" |
*
* @param {Live_Caption_Paste_New_TokenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_paste_new_token = /** @type {((inputs?: Live_Caption_Paste_New_TokenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Paste_New_TokenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller le nouveau jeton")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Token einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla il nuovo token")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте новый токен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar nuevo token")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴新令牌")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいトークンを貼り付ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया टोकन पेस्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cole o novo token")
	return /** @type {LocalizedString} */ ("Paste new token")
});